module.exports = __webpack_public_path__ + "img/steps.5cbd37e2.png";